import React from 'react';
import PlaceOutlinedIcon from '@material-ui/icons/PlaceOutlined';

import InfoListItem from '../InfoListItem';

import useCar from '../../../../../../context/useCar';
import { useTranslations } from 'components/utilities';

const PickUpLocationInfoListItem = () => {
	const { t } = useTranslations();

    const { pickupLocation } = useCar();

	return (
		<InfoListItem
			icon={PlaceOutlinedIcon}
			title={t('car.pickupCity')}
			info={pickupLocation?.address}
			hasAction={false}
		/>
	);
};

export default PickUpLocationInfoListItem;
